import axios from 'axios';
import { useQuery } from '@tanstack/react-query';

// Eagle Eye (pipeline:view): a page of people with their whole journey.
// { bucket: active | nurture | done | dead | all, q, page }
export const useJourneys = ({ bucket, q, page }, opts = {}) =>
  useQuery(
    ['journeys', bucket, q || '', page],
    async () => (await axios.get('/journeys', { params: { bucket, q: q || undefined, page } })).data,
    { keepPreviousData: true, staleTime: 30000, refetchOnWindowFocus: true, ...opts },
  );
